// extracted by mini-css-extract-plugin
export default {"wrapper":"Buttons_wrapper__cDWIQ","controls":"Buttons_controls__6W8Ai","control":"Buttons_control__yVB2E"};